/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import './more-menu.css';
import '../Reports/reports.css';
import Select from 'react-select';
import moment from 'moment';
import $ from 'jquery';
import 'datatables.net-dt/css/jquery.dataTables.css';
import { withRouter } from 'react-router-dom';
import { COMMON, MORE_MENU_SCREEN, ALL_ROUTES } from '../../global/Constants';
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import { MORE_MENU_TYPES } from '../../global/Enum';
require('datatables.net');

let selectedData = null;
let selectedTicket = null;

const message = (data) => {
    selectedTicket = data;
}

function eventFire(el, etype) {
    if (el.fireEvent) {
        el.fireEvent('on' + etype);
    } else {
        var evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
    }
}

class ContactUsPage extends Component {

    constructor(props) {
        super(props)
        this.datatable = null;

        this.state = {
            allStatusData: [
                { value: 0, label: "Pending" },
                { value: 1, label: "Open" },
                { value: 2, label: "Resolved" },
                { value: 3, label: "Closed" },
                { value: 4, label: "In Progress" }
            ],
            selectedStatus: null,
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            this.initializeDataTable();
            //this.getUserFeedbackByUserId(null);
            const data = this.props.location.state;
            if (data?.activeTab === MORE_MENU_TYPES.CONTACT_US) {
                this.getUserFeedbackByUserId(null);
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    initializeDataTable() {

        this.$el = $(this.el);
        this.dataTable = this.$el.DataTable({
            columns: [
                { title: COMMON.TICKET_ID },
                { title: COMMON.DATE },
                { title: COMMON.COMPLAIN_TYPE },
                { title: COMMON.STATUS }
            ]
        });

        var dataTableKrishak = this.dataTable;

        $(document).ready(function () {

            $('#example').on('click', 'tbody td', function () {

                //get textContent of the TD
                if (this.textContent.includes("#")) {
                    // window.location = ALL_ROUTES.SEND_FEEDBACK_ROUTE;
                    message(this.textContent);
                    eventFire(document.getElementById('redirect'), 'click');

                }
            })

            $('#mySearchBox').keyup(function () {
                dataTableKrishak.search($(this).val()).draw();
            });

            $('#example thead tr').clone(true).appendTo('#example thead');
            $('#example thead tr:eq(1) th').each(function (i) {

                var title = $(this).text();
                $(this).html('<input type="text" placeholder="Search ' + title + '" />');

                $('input', this).on('keyup change', function () {
                    if (dataTableKrishak.column(i).search() !== this.value) {
                        dataTableKrishak
                            .column(i)
                            .search(this.value)
                            .draw();
                    }
                });
            });
        });
    }

    getUserFeedbackByUserId = async (forSendFeedback) => {
        if (Utilities.isNetworkConnected()) {
            var body = JSON.stringify({

            });
            try {
                ApiServices.getUserFeedbackByUserId(body).then(async response => {
                    var status = response.success;
                    if (status) {
                        const { selectedStatus } = this.state;
                        let newArrayOfObj = response.data;
                        let tempMainArray = [];
                        selectedData = null;
                        for (var i = 0; i < newArrayOfObj.length; i++) {

                            let tempArray = [];

                            tempArray.push('<a>' + "#" + newArrayOfObj[i]["ticket_id"] + '</a>');
                            tempArray.push(moment(newArrayOfObj[i]["date"], "DD/MM/YYYY hh:mm:sss").format("DD MMM YYYY"));
                            tempArray.push(newArrayOfObj[i]["complain_type"]);

                            switch (newArrayOfObj[i]["status"]) {
                                case "Pending": tempArray.push(`<span class="to-resubmit"
                                    style="padding: 0 10px;border-radius: 10px;color: #fff;">` +
                                    newArrayOfObj[i]["status"] +
                                    `</span>`);
                                    break;
                                case "Open": tempArray.push(`<span class="to-start"
                                    style="padding: 0 10px;border-radius: 10px;color: #fff;">` +
                                    newArrayOfObj[i]["status"] +
                                    `</span>`);
                                    break;
                                case "Resolved": tempArray.push(`<span class="completed"
                                    style="padding: 0 10px;border-radius: 10px;color: #fff;">` +
                                    newArrayOfObj[i]["status"] +
                                    `</span>`);
                                    break;
                                case "Closed": tempArray.push(`<span class="hold"
                                    style="padding: 0 10px;border-radius: 10px;color: #fff;">` +
                                    newArrayOfObj[i]["status"] +
                                    `</span>`);
                                    break;
                                case "In Progress": tempArray.push(`<span class="in-progress"
                                    style="padding: 0 10px;border-radius: 10px;color: #fff;">` +
                                    newArrayOfObj[i]["status"] +
                                    `</span>`);
                                    break;
                            }
                            if (selectedStatus === null) {
                                tempMainArray.push(tempArray);
                            } else if (selectedStatus.label === newArrayOfObj[i]["status"]) {
                                tempMainArray.push(tempArray);
                            }

                            if (("#" + newArrayOfObj[i]["ticket_id"]) === selectedTicket) {
                                selectedData = newArrayOfObj[i]
                            }
                        }
                        this.dataTable.clear();
                        this.dataTable.rows.add(tempMainArray);
                        this.dataTable.draw();
                    }
                    if (forSendFeedback !== null) {
                        if (forSendFeedback === true) {
                            this.props.sendFeedback(selectedData);
                        } else {
                            this.props.sendFeedback(null);
                        }
                    }

                }).catch(error => {
                    Utilities.LogPrint("getUserFeedbackByUserId", error);
                });
            } catch (error) {
                Utilities.LogPrint("getUserFeedbackByUserId", error);
            }
        }

    }

    handleTableRefresh = () => {
        this.getUserFeedbackByUserId(null);
    }

    handleCropGroupChange = selectedStatus => {
        this.setState({ selectedStatus }, () => {
            this.getUserFeedbackByUserId(null);
        });
    }

    handleCreateClick = () => {
        this.getUserFeedbackByUserId(false);
    }

    handleRedirectClick = () => {
        this.getUserFeedbackByUserId(true);
    }

    render() {
        const { isActive } = this.props;
        const { allStatusData, selectedStatus } = this.state;
        return (
            <div id="contactUs  " className={isActive ? "more-menu-body" : "more-menu-body d-none"}>
                <div className="contactus">
                    <div className="row">
                        <div className="col-12">
                            <h6 className="mb-3"><a className="more-menu-back" onClick={() => { this.props._sendToParent(false) }}> <i className="customic ic-back-button"></i> </a>{MORE_MENU_SCREEN.CONTACT_US}</h6>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12 d-flex justify-content-end">
                            <button onClick={() => this.handleCreateClick()} id="create_btn" className="btn btn-primary w-50 create-btn">Create</button>
                            <button onClick={() => this.handleRedirectClick()} id="redirect" className="d-none">Create</button>
                        </div>
                    </div>
                    <div className="row all-filters">
                        <div className="col-md-6 col-12">
                            <div className="form-group">
                                <Select className=" max-w-360"
                                    value={selectedStatus}
                                    onChange={this.handleCropGroupChange}
                                    options={allStatusData}
                                    placeholder={COMMON.STATUS}
                                    isClearable={true}
                                />
                            </div>
                        </div>
                        <div className="col-md-5 col-12">
                            <div className="form-group">
                                <input className="form-control" id="mySearchBox" placeholder={COMMON.SEARCH} />
                            </div>
                        </div>
                        <div className="refresh-contact-us">
                            <div className="form-group">
                                <i className="customic ic-refresh mr-3" id="refresh_btn" onClick={this.handleTableRefresh}></i>
                            </div>
                        </div>
                    </div>
                    <table id="example" ref={(el) => (this.el = el)} className="display table table-responsive table-striped table-bordered mobile-number" />
                </div>
            </div>
        );
    }
}

export default withRouter(ContactUsPage)